const SolutionIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_45905_59812)">
                <path
                    d="M8.75 8.17969C8.75 7.07969 9.65 6.17969 10.75 6.17969V3.17969H2.75C1.65 3.17969 0.75 4.07969 0.75 5.17969V13.1797H3.75C3.75 14.2797 4.65 15.1797 5.75 15.1797C6.85 15.1797 7.75 14.2797 7.75 13.1797H10.75V10.1797C9.65 10.1797 8.75 9.27969 8.75 8.17969Z"
                    stroke="white"
                />
                <path
                    d="M12.75 18.1797C12.75 19.2797 11.85 20.1797 10.75 20.1797V23.1797H18.75C19.85 23.1797 20.75 22.2797 20.75 21.1797V13.1797H17.75C17.75 12.0797 16.85 11.1797 15.75 11.1797C14.65 11.1797 13.75 12.0797 13.75 13.1797H10.75V16.1797C11.85 16.1797 12.75 17.0797 12.75 18.1797Z"
                    stroke="white"
                />
                <path
                    d="M5.75 15.1797C4.65 15.1797 3.75 14.2797 3.75 13.1797H0.75V21.1797C0.75 22.2797 1.65 23.1797 2.75 23.1797H10.75V20.1797C11.85 20.1797 12.75 19.2797 12.75 18.1797C12.75 17.0797 11.85 16.1797 10.75 16.1797V13.1797H7.75C7.75 14.2797 6.85 15.1797 5.75 15.1797Z"
                    stroke="white"
                />
                <path
                    d="M18.6 8.36992C19.62 8.78992 20.11 9.95992 19.68 10.9799L22.45 12.1299L24.75 6.58992C25.17 5.56992 24.69 4.39992 23.67 3.97992L16.28 0.919922L15.51 2.76992C14.49 2.34992 13.32 2.82992 12.9 3.84992C12.48 4.86992 12.96 6.03992 13.98 6.45992L13.21 8.30992L15.98 9.45992C16.4 8.43992 17.57 7.94992 18.59 8.37992L18.6 8.36992Z"
                    stroke="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_45905_59812">
                    <rect width="26" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

SolutionIcon.displayName = 'HintIcon'

export default SolutionIcon
